<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: HomePage
 * @Description: 首页
 * @FilePath: /app-tikfriend_web/src/pages/HomePage.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:16:23
 * @LastEditors: hselenat
 * @LastEditTime: 2021-07-09 10:19:07
 * @example: <HomePage />
-->
<template>
  <div class="home">
    <nav-bar @handlerLi="gotoPage" />
    <bodies :curPage="curPage" :curData="contentData" :isShowWindows="isShowWindows" />
    <footer-bar :describeData="contentData.id" />
  </div>
</template>

<script>
import Bodies from '../components/Bodies.vue'
import FooterBar from '../components/FooterBar.vue'
import NavBar from '../components/NavBar.vue'
export default {
  components: {  NavBar, Bodies, FooterBar },
  name: 'HomePage',
  data () {
    return {
      curPage: 'chat',
      contentData: this.$api.Index_item[0],
      isShowWindows: false
    }
  },
  methods: {
    gotoPage(item) {
      console.log(item)
      this.isShowWindows = item.compName == 'work' ? true : false
      console.log('isShowWindows', this.isShowWindows)
      this.contentData = this.$api.Index_item.find(x => x.compName == item.compTitle)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.home {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue